<div class='se-container'>
    <se-spinner class='maincontentspinner' [isBusy]='chart?.isBusy'>
        <div class='maincontent'>

            <ng-container *ngIf='reportingWithoutTrace && !sopInstanceUID'>
                <div class='se-content'>
                    <se-fullscreen class='chart' [enableFullscreenMode]='false' [fullscreen]='fullscreen'>
                        <div id='noTracing'>
                            <h4>{{ 'ErrorNoTracing' | translate }}</h4>
                        </div>
                    </se-fullscreen>
                </div>
            </ng-container>

            <ng-container *ngIf='!reportingWithoutTrace || sopInstanceUID'>

                <ecg-summary *ngIf='!fullscreen && !mediaService.is16_9' [layer]='chart?.activeLayer'
                             [hidden]='!ecgState.detailsState.visible || chart?.layers.length !== 1 || !ecgState.detailsState.summaryState.visible'>
                </ecg-summary>

                <div class='se-content'>
                    <se-fullscreen class='chart' [enableFullscreenMode]='false' [fullscreen]='fullscreen'>

                        <caliper-and-measures class='measures-content' *ngIf='showCaliperAndMeasures'
                                              [customMeasureButtons]='customMeasureButtons' [readOnly]='readOnly'
                                              [showGlobalMeasures]='canShowGlobalMeasures()'
                                              [showCustomMeasures]='canShowCustomMeasures()'
                                              [showCaliperMeasures]='canShowCaliperMeasures()'
                                              [globalMeasures]='chart?.activeLayer?.ecgData?.originalWaveform.annotations'
                                              [customMeasures]='customMeasures'
                                              [caliperMeasures]='chartComponent.measuresSummary.measuresHandle.measuresList'
                                              (caliperMeasuresRemove)='chartComponent.onMeasuresRemove($event)'
                                              (caliperMeasuresRemoveAll)='chartComponent.clearAllMeasures()'
                                              (closeCustomMeasuresClicked)='onCloseCustomMeasures()'>
                        </caliper-and-measures>

                        <div class='chart-container'>
                            <ecg-chart class='chart' #chartComponent [chart]='chart'
                                       [class.item-collapse]='showLeadsAnnotations' [title]='chartTitle'
                                       [hideWhileCentering]='hideWhileCentering'
                                       (caliperActivated)='onCaliperActivate($event)'>
                            </ecg-chart>
                            <leads-annotations [class.full-leads-annotations-width]='showLeadsAnnotations'
                                               #leadsAnnotations
                                               *ngIf='showLeadsAnnotations && ecgState.detailsState.visible && chart?.layers.length === 1'
                                               class='annotations'
                                               [channels]='chart?.activeLayer?.ecgData?.derivedWaveform.channels'>
                            </leads-annotations>
                            <!-- layout-fab-tools -->
                            <layout-fab-tools
                                class='layout-fab-tools'
                                [class.is-fullscreen]="fullscreen"
                                (fullscreenChange)='onFullscreenChange()'
                                (lowFilterChange)='onLowFilterChange($event)'
                                [(ecgConfiguration)]='ecgConfiguration'
                                [arrangementConfiguration]='arrangementConfiguration'
                                [schillerFilters]='schillerFilters'
                                [enabledPrintAsDisplayed]='printAsDisplayed'
                                [showCustomMeasuresButton]='showCustomMeasuresButton'
                                [showLeadsAnnotationsButton]='showLeadsAnnotationsButton'
                                [showGlobalMeasures]='showGlobalMeasures'
                                [showLeadsAnnotations]='showLeadsAnnotations'
                                [chartLayersNumber]='chart.layers?.length'
                                (customMeasuresChange)='onCustomMeasuresChange($event)'
                                (leadsAnnotationsChange)='onLeadsAnnotationsChange($event)'>
                            </layout-fab-tools>

                            <fixed-filters class='fixed-filters' [filters]='chart?.activeLayer?.filters'
                                           [schillerFilters]='schillerFilters'
                                           [class.item-collapse]='showLeadsAnnotations'
                                           [manufacturer]='chart?.activeLayer?.study?.manufacturer'>
                            </fixed-filters>

                            <!-- <measures-fab-tools *ngIf="enableMeasureOptions" class="measures-fab-tools"
                                [showCustomMeasures]="showCustomMeasures" // prende da showGlobalMeasures
                                [showLeadsAnnotations]="showLeadsAnnotations" // \non serve?
                                [showGlobalAnnotations]="showGlobalAnnotations" // in più?
                                [showCustomMeasuresButton]="showCustomMeasuresButton" // li passo
                                [showLeadsAnnotationsButton]="showLeadsAnnotationsButton" // li passo
                                [showGlobalAnnotationsButton]="showGlobalAnnotationsButton" // non serve
                                (customMeasuresChange)="onCustomMeasuresChange($event)" // ce l'ho
                                (leadsAnnotationsChange)="onLeadsAnnotationsChange()"// ce l'ho
                                (globalAnnotationsChange)="onGlobalAnnotationsChange()" // in più?
                                customMeasuresTooltip="{{ 'GLOBAL_ANNOTATIONS' | translate }}"
                                globalAnnotationsTooltip="{{ 'GLOBAL_ANNOTATIONS' | translate }}"
                                leadsAnnotationsTooltip="{{ 'LEADS_ANNOTATIONS' | translate }}">
                            </measures-fab-tools> -->
                        </div>

                    </se-fullscreen>

                    <div class='summary'>
                        <ecg-summary class='ecgsummary' *ngIf='!fullscreen && mediaService.is16_9'
                                     [layer]='chart?.activeLayer'
                                     [hidden]='!ecgState.detailsState.visible || chart?.layers.length !== 1 || !ecgState.detailsState.summaryState.visible'>
                        </ecg-summary>
                    </div>

                </div>
            </ng-container>

        </div>
    </se-spinner>
</div>

<se-modaldialog [buttonCancel]='customDialog.buttonCancel' [buttonOk]='customDialog.buttonOk'
                [header]='customDialog.title | translate' [(visible)]='customDialog.visible'
                (buttonClick)='onCustomDialog($event)'
                class='custom-data-dialog'
                [windowSize]='3'>
    <div content>
        {{ customDialog.description | translate }}
    </div>
</se-modaldialog>
